import React from 'react';
import { useTranslation } from 'react-i18next';
import LogoContainer from '../LogoContainer';
import { XIcon } from '../../../../SVG';
import { MobileStates, WidgetStateChangeType, WidgetStates } from '../../Widget';
import { THEME } from '../../../../clearstep/util/Theme';
import { getIntialStateIsHidden } from '../../../utils/Params';
import { useRingStyle } from '../../../../tailwind_common/util';
import { useTranslationService } from '../../../../../util/i18n/TranslationServiceProvider';
import { WIDGET_NAMESPACE } from '../../../../../util/i18n/constants';
var Text = function () {
    var _a, _b;
    var tService = useTranslationService().tService;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "mb-3 text-base font-normal leading-[120%] text-black" }, t('widget.expandedGreeting-sm.header', 'Hi there.')),
        React.createElement("p", { className: "text-base font-normal leading-[120%] text-black" }, ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.expandedSubheaderText)
            ? tService((_b = THEME.widgetCustomizations) === null || _b === void 0 ? void 0 : _b.expandedSubheaderText, {
                ns: WIDGET_NAMESPACE,
            })
            : t('widget.expandedGreeting-sm.subeader', 'How can I help you today?'))));
};
export var ExpandedGreetingHeader = function (_a) {
    var setWidgetState = _a.setWidgetState, iconPath = _a.iconPath, mobileState = _a.mobileState;
    var initialState = getIntialStateIsHidden(mobileState)
        ? WidgetStates.HIDDEN
        : WidgetStates.COLLAPSED;
    var ringStyle = useRingStyle();
    return mobileState === MobileStates.MOBILE ? (React.createElement("div", { className: "px-5 pb-[53px] pt-5" },
        React.createElement("div", { className: "flex justify-between pb-4" },
            iconPath ? React.createElement(LogoContainer, { sizeClasses: "w-8 h-8", iconPath: iconPath }) : React.createElement("div", null),
            React.createElement("button", { onClick: function () { return setWidgetState(initialState, WidgetStateChangeType.MANUAL); }, className: "tw-focus m-neg-2" },
                React.createElement(XIcon, { className: "p-2", stroke: "#9CA3AF" }))),
        React.createElement(Text, null))) : (React.createElement("div", { className: "relative rounded-t-md" },
        !iconPath && (React.createElement("button", { onClick: function () { return setWidgetState(WidgetStates.HIDDEN, WidgetStateChangeType.MANUAL); }, className: "tw-focus absolute right-4 top-4 p-1", style: ringStyle },
            React.createElement(XIcon, { stroke: "#9CA3AF" }))),
        React.createElement("div", { className: "flex justify-between p-4" },
            React.createElement("div", null,
                React.createElement(Text, null)),
            iconPath && React.createElement(LogoContainer, { sizeClasses: "w-10 h-10", iconPath: iconPath }))));
};
export default ExpandedGreetingHeader;
